import styled from "styled-components";

export const InterlinkingContainer = styled.div`
    margin: 4rem 0;
    background-color: #fff;
    padding: 2rem 1rem;
    width: 100%;
    border-radius: 12px;
`;

export const InterlinkingItemContainer = styled.div`
    font-size: 12px;
    display: flex;
    flex-wrap: wrap;
`;

export const InterlinkingItemTitle = styled.span`
    font-weight: 600;
    padding-right: 4px;
`;

export const InterlinkingItem = styled.a`
    padding-right: 4px;
    padding-bottom: 8px;
`;
